import React from "react";
import { Link } from "react-router-dom";
import PublicNav, { PublicFooter } from "../components/PublicNav";
import SEO from "../components/SEO";
import { LEGAL, UPDATED } from "./legalData";
import "./legal.css";

/* One template for all legal/policy pages (privacy, terms, cookies, gdpr),
   content-driven from legalData.js. Indexable, self-canonical, breadcrumbed. */
export default function LegalPage({ docKey }) {
  const doc = LEGAL[docKey];
  if (!doc) return null;
  const path = `/${doc.slug}`;
  const others = ["privacy", "terms", "cookies", "gdpr"].filter((k) => k !== docKey);

  return (
    <div className="csx">
      <SEO
        title={doc.title}
        description={doc.description}
        canonicalPath={path}
        breadcrumbs={[{ label: doc.title, path }]}
      />
      <div className="csx-page">
        <PublicNav />
        <main>
          <section className="land-section">
            <div className="wrap lg-wrap">
              <h1 className="lg-h1">{doc.title}</h1>
              <p className="lg-updated">Last updated: {UPDATED}</p>
              <p className="lg-intro">{doc.intro}</p>

              {doc.sections.map((sec, i) => (
                <section className="lg-sec" key={i}>
                  <h2 className="lg-h2">{sec.h}</h2>
                  {sec.p.map((para, j) => (
                    <p className="lg-p" key={j}>
                      {para}
                    </p>
                  ))}
                  {sec.list ? (
                    <ul className="lg-list">
                      {sec.list.map((li, k) => (
                        <li key={k}>{li}</li>
                      ))}
                    </ul>
                  ) : null}
                </section>
              ))}

              <p className="lg-cross">
                See also:{" "}
                {others.map((k, i) => (
                  <React.Fragment key={k}>
                    <Link to={`/${LEGAL[k].slug}`} className="t-accent">
                      {LEGAL[k].title}
                    </Link>
                    {i < others.length - 1 ? " · " : ""}
                  </React.Fragment>
                ))}
              </p>
            </div>
          </section>
        </main>
        <PublicFooter />
      </div>
    </div>
  );
}
